import "./UserProfile.css";
import { useEffect, useState } from "react";
import { Container, Row, Col, ListGroup, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fetchUserApi } from "../../api/usersApi";
import { useSelector } from "react-redux";
import { getStorageToken, useLogout } from "../../utilities";
import { LoadingSpinner, ModalMessage } from "../../components";
import { LinkContainer } from "react-router-bootstrap";

export default function UserProfile() {
  // displays the user's profile data, as well as a menu
  // with links to subpages

  const fieldNames = [
    "firstName",
    "lastName",
    "email",
    "phone",
    "country",
    "street",
    "city",
    "province",
    "postalCode",
  ];
  const labels = [
    "First Name",
    "Last Name",
    "Email",
    "Phone",
    "Country",
    "Street",
    "City",
    "Province",
    "Postal Code",
  ];

  const userMenuItems = [
    { label: "See My Cart", linkPath: "/cart" },
    { label: "View My Orders", linkPath: "/user/my-orders" },
    { label: "See My Reviews", linkPath: "/user/my-reviews" },
    { label: "Edit My Profile", linkPath: "/user-edit-profile" },
  ];

  const { id, stayLoggedIn } = useSelector((state) => state.user);
  const logout = useLogout();

  const [profileData, setProfileData] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const abortController = new AbortController();
    const fetchData = async () => {
      // returns json
      setIsLoading(true);
      try {
        const token = getStorageToken(stayLoggedIn);
        const res = await fetchUserApi(id, token, abortController.signal);
        return res;
      } catch (error) {
        if (error?.status === 401) {
          //unautorized, eg token expired
          logout();
        }
        setErrorMsg("Could not load data. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData()
      .then((res) => setProfileData(res))
      .catch((error) => {
        setErrorMsg("Could not load data. Please try again later.");
      });
    return () => abortController.abort();
  }, [stayLoggedIn, id, logout]);

  return (
    <Container>
      {errorMsg && (
        <ModalMessage
          type="danger"
          message={errorMsg}
          setErrorMsg={setErrorMsg}
        />
      )}
      <Row className="mt-5  align-items-center">
        <h1 className="mb-4">
          Welcome back{profileData && `, ${profileData.firstName}`}!
        </h1>

        <Col className="mx-2 mt-5">
          <Row className="d-flex justify-content-around">
            <Col md={4}>
              <h5>Manage Account</h5>
              {userMenuItems.map((item, idx) => {
                return (
                  <div className="d-grid gap-2" key={item.label}>
                    <LinkContainer to={item.linkPath} className="mt-1">
                      <Button variant="light">{item.label}</Button>
                    </LinkContainer>
                  </div>
                );
              })}
              {/* </Col> */}
            </Col>
            <Col md={6} className="profile-data-section">
              <h5>Profile data</h5>
              {isLoading && <LoadingSpinner />}
              {profileData &&
                labels.map((label, idx) => {
                  if (
                    label === "Province" &&
                    profileData.country !== "Canada"
                  ) {
                    label = "State";
                  } else if (
                    label === "Postal Code" &&
                    profileData.country !== "Canada"
                  ) {
                    label = "Zip Code";
                  }
                  return (
                    <Row key={idx} >
                      <Col style={{ marginLeft: "5px" }} xs={4}>
                        <ListGroup variant="flush">
                          <ListGroup.Item style={{ padding: "0 " }}>
                            <span style={{ fontWeight: "600" }}>{label}:</span>
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                      <Col >
                        <ListGroup variant="flush">
                          <ListGroup.Item>
                            {profileData[fieldNames[idx]] ? (
                              profileData[fieldNames[idx]]
                            ) : (
                              <LinkContainer
                                style={{ color: "gray", fontWeight: "lighter" }}
                                to="/user-edit-profile"
                              >
                                <Link>add</Link>
                              </LinkContainer>
                            )}
                          </ListGroup.Item>
                        </ListGroup>
                      </Col>
                    </Row>
                  );
                })}
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
